export function getFileNameFromURL(url) {
  const urlParts = url.split('/');
  const fileName = urlParts.pop();
  const urlWithoutFileName = urlParts.join('/');
  return {
    urlWithoutFileName,
    fileName
  };
}
//# sourceMappingURL=getFileNameFromURL.js.map